import { render } from "./PlayoutPreviewV2.vue?vue&type=template&id=2ae67616"
import script from "./PlayoutPreviewV2.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayoutPreviewV2.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/TVPlayoutV2/PlayoutPreviewV2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ae67616"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ae67616', __exports__)) {
    api.reload('2ae67616', __exports__)
  }
  
  module.hot.accept("./PlayoutPreviewV2.vue?vue&type=template&id=2ae67616", () => {
    api.rerender('2ae67616', render)
  })

}


export default __exports__